import React, { Component } from 'react';
import './ListSubsidiaries.css';
import { Col } from 'reactstrap';
import swal from "sweetalert";
import { withRouter } from '../../utils/router-compat';
class ListSubsidiaries extends Component {
  // constructor(props) {
  //   super(props);
  // }
  removeSubsidiaries = (index) => {
    swal({
      title: "",
      text: "Are you sure, you want to delete subsidiary?",
      icon: "warning",
      buttons: ["No", "Yes"]
    }).then(isConfirm => {
      if (isConfirm) {
        this.props.removeSubsidiaries(index);
      }
    });
  }
  editSubsidiaries(index, display = false) {
    this.props.editSubsidiaries(index, display);
  }
  addMoreSubsidiaries = () => {
    this.props.addMoreSubsidiaries(true);
  }
  render() {
    let listSubsidiaries = this.props.listSubsidiaries;
    let is_draft = this.props.is_draft ? false : true;
    return (
      <>
        <Col style={{ paddingLeft: '0', paddingRight: '0' }}>
          <div className="subsidiaries-list-title-wrapp">
            <span className="subsidiaries-list-title">Subsidiary Name</span>
          </div>
          {
            listSubsidiaries.map((item, i) => (
              <div className="subsidiaries-list-warpp d-flex-row" style={{ justifyContent: 'space-between' }}>
                <span onClick={() => this.editSubsidiaries(i, true)} className="subsidiaries-name link-blue cursor-pointer">{item.controls.subsidiaryName.value}</span>
                {
                  is_draft && <div>
                    <img className="cursor-pointer" src="images/edit.svg" alt='edit' onClick={() => this.editSubsidiaries(i)} />&nbsp;&nbsp;&nbsp;
                    <img className="cursor-pointer" src="images/delete.svg" alt='delete' onClick={() => this.removeSubsidiaries(item.controls.uuid)} />
                  </div>
                }
              </div>
            ))
          }
          {/* {
            is_draft &&
            <div className="subsidiaries-list-warpp d-flex-row" onClick={() => this.addMoreSubsidiaries()}>
              <img className="cursor-pointer" src="images/add.svg" alt='add' />&nbsp;&nbsp;
              <span className="subsidiaries-name" style={{ cursor: 'pointer' }}>Add More Subsidiaries</span>
            </div>
          } */}
        </Col>
      </>
    );
  }
}

export default withRouter(ListSubsidiaries);